export default function initGraduatedCarousel() {
  const carousel = document.querySelector("[data-graduated-carousel]");

  if (!carousel) {
    return;
  }

  const track = carousel.querySelector("[data-graduated-track]");
  const prevButton = carousel.querySelector("[data-graduated-prev]");
  const nextButton = carousel.querySelector("[data-graduated-next]");

  if (!track || !prevButton || !nextButton) {
    return;
  }

  const cards = Array.from(track.querySelectorAll(":scope > .team-member"));
  const cardsPerPage = 4;

  if (!cards.length) {
    return;
  }

  const fragment = document.createDocumentFragment();

  for (let index = 0; index < cards.length; index += cardsPerPage) {
    const slide = document.createElement("div");
    slide.className = "graduated-carousel__slide";

    cards.slice(index, index + cardsPerPage).forEach((card) => {
      slide.appendChild(card);
    });

    fragment.appendChild(slide);
  }

  track.replaceChildren(fragment);

  const slides = Array.from(track.children);
  let currentIndex = 0;

  function update() {
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex === slides.length - 1;
    carousel.classList.toggle("is-single-page", slides.length <= 1);
  }

  prevButton.addEventListener("click", () => {
    if (currentIndex === 0) {
      return;
    }

    currentIndex -= 1;
    update();
  });

  nextButton.addEventListener("click", () => {
    if (currentIndex >= slides.length - 1) {
      return;
    }

    currentIndex += 1;
    update();
  });

  update();
}
